// Inline SVG social marks. Written by hand rather than pulled from an icon
// package: the app has no icon dependency today and this glyph isn't worth
// adding one for. Inherits `currentColor`, so a link only has to set its own
// colour.
//
// Instagram is the only social account the site links to. When a Twitter/X or
// Facebook link is added, its mark belongs here alongside this one.

interface IconProps {
  size?: number
}

export function InstagramIcon({ size = 18 }: IconProps) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" focusable="false"
    >
      <rect x="2" y="2" width="20" height="20" rx="5.5" />
      <circle cx="12" cy="12" r="4.2" />
      <circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  )
}
